// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".editDevice_formNote{margin:16px 0 -8px}", "",{"version":3,"sources":["webpack://./src/pages/EditDevice/EditDevice.scss"],"names":[],"mappings":"AAAA,qBAEI,kBAAA","sourcesContent":[".editDevice_formNote {\n    // Negative bottom margin is because of form footer top margin.\n    margin: 16px 0 -8px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
